import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { useVehicleControlsStateHook } from 'console/shared/hooks/device/legacy/vehicle-controls';
import { VehicleControlContent } from './types';
export const VehicleControlProvider = memo(function VehicleControlProvider(props) {
    const { children, vehicle_control_config } = props;
    const useVehicleControlState = useVehicleControlsStateHook(vehicle_control_config);
    const vehicle_control_state = useVehicleControlState();
    const vehicle_control = useMemo(() => ({
        ...vehicle_control_config,
        ...vehicle_control_state,
    }), [vehicle_control_config, vehicle_control_state]);
    return (_jsx(VehicleControlContent.Provider, { value: vehicle_control, children: children }));
});
export const useVehicleControl = () => useContext(VehicleControlContent);
